<template>
  <div class="app-container">
    <base-header v-if="showType" activeIndex="-1" />

    <div  :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <swiper :options="swiperOption" v-if="swiperData.length">
        <div class="swiper-slide" v-for="(item, i) in swiperData" :key="i" @click="handleJump(item)">
          <img class="banner-img" :src="item.imgUrl" />
        </div>
        <!-- <div v-if="swiperData.length>1" class="swiper-pagination" slot="pagination"></div> -->
      </swiper>

      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'"
        v-if="swiperData.length < 1">
        <h1 class="title">智投全球 剑指非凡</h1>
        <h1 class="titles">智投全球</h1>
        <h1 class="titles">剑指非凡</h1>
        <p class="banner-content-intro">专业黄金平台 · 匠心成就梦想</p>
        <div class="banner-content-download">
          <span class="banner-content-download-btn" @click="toScroll('BaseDownLoadRef')">APP下载</span>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/home/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/home/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="top-box">
        <div class="top-flex">
          <div class="left">
            <div>伦敦金</div>

            <div>
              <span>{{ London.goldRise }}</span>

              <span :class="London.goldStatus ? 'slider' : 'slider1'">{{ London.goldPer }}</span>
            </div>
          </div>

          <div :class="London.goldStatus ? 'right' : 'right rights'">{{ London.goldStatus ? London.gold + '↑' :
            London.gold + '↓' }}
            
          </div>
        </div>
        <div class="top-flex">
          <div class="left">
            <div>伦敦银</div>
            <div>
              <span>{{ London.silverRise }}</span>
              <span :class="London.silverStatus ? 'slider' : 'slider1'">{{ London.silverPer }} </span>
            </div>
          </div>
          <div :class="London.silverStatus ? 'right' : 'right rights'">{{ London.silverStatus ? London.silver + '↑'
            :
            London.silver + '↓' }}
          </div>
        </div>
        <!-- <div class="top-flex">
          <div class="left">
            <div>美国原油 <span class="refer"></span></div>
            <div>
              <span>{{ London.usdRise }}</span>
              <span :class="London.usdStatus ? 'slider' : 'slider1'">{{ London.usdPer }} </span>
            </div>
          </div>
          <div :class="London.usdStatus ? 'right' : 'right rights'">{{ London.usdStatus ? London.usd + '↑' :
            London.usd + '↓' }}</div>
        </div>
        <div class="top-flex">
          <div class="left">
            <div>英国原油<span class="refer"></span></div>
            <div>
              <span>{{ London.nasRise }}</span>
              <span :class="London.nasStatus ? 'slider' : 'slider1'">{{ London.nasPer }}</span>
            </div>
          </div>
          <div :class="London.nasStatus ? 'right' : 'right rights'">{{ London.nasStatus ? London.nas + '↑' :
            London.nas + '↓' }}</div>
        </div> -->

      </div>
      <div class="topWapbox">
        <div class="topbox">
          <div class="flex boxs">
            <div class="left flex1">A</div>
            <div class="right">
              <span class="txts">伦敦金</span>
              <div class="cont">
                <span class="txt" style="margin-right: 6px;">{{ London.goldRise || 0 }}</span>
                <span class="txt" style="color: #fa2314">{{ London.goldPer }}</span>
              </div>
            </div>
          </div>
          <div class="flex boxs">
            <div class=" left flex1 " style="background: #A915AC;">B</div>
            <div class="right">
              <span class="txts">伦敦银</span>
              <div class="cont">
                <span class="txt" style="margin-right: 6px;">{{ London.silver || 0 }}</span>
                <span class="txt" style="color: #fa2314"> {{ London.silverPer }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="flex boxs">
            <div class=" left flex1 " style="background: #15AC36">C</div>
            <div class="right">
              <span class="txts">美国原油 <span style="color: #fa2314;"></span></span>
              <div class="cont">
                <span class="txt" style="margin-right: 6px;">{{ London.usdRise }}</span>
                <span class="txt" style="color: #fa2314">{{ London.usdPer }} </span>
              </div>
            </div>
          </div>
          <div class="flex boxs">
            <div class="left flex1">D</div>
            <div class="right">
              <span class="txts">英国原油 <span style="color: #fa2314;"></span></span>
              <div class="cont">
                <span class="txt" style="margin-right: 6px;">{{ London.nasRise }}</span>
                <span class="txt" style="color: #fa2314;width: 30px;">{{ London.nasPer }} </span>
              </div>
            </div>
          </div> -->

        </div>
      </div>

    </div>
  
    <div class="content-box " style="position: relative;">
      <div class="title__layer title_layers ">
   
        <h1 class="title">金融市场动态最新<span>行情资讯</span></h1>
        <h1 class="titles">金融市场动态</h1>
        <h1 class="titles">最新<span>行情资讯</span></h1>
        <p>市场动态一览，投资风向标</p>
      </div>
      <Market :isShow="isShow" />
     

    </div>
  
    <div class="expert__layer content-box">
      <ExpertComments />
    </div>
    <div class="content-box">
  
      <div class="title__layer">
        <h1 class="title">专注黄金交易 <span>一站式</span>管家服务</h1>
        <h1 class="titles">专注黄金交易 </h1>
        <h1 class="titles"> <span>一站式</span>管家服务</h1>
        <p>金牌管家，财富之路领航者</p>
      </div>
      <BaseService />
   
    </div>
 
    <div class="content-box">
      <div class="title__layer">
        <h1><span>实时</span>数据分析</h1>
        <p>洞悉市场脉动，掌握交易先机</p>
      </div>

      <DataAnalyse />
    </div>

    <BaseDownLoad ref="BaseDownLoadRef" />

    <base-footer v-if="showType" />
  </div>
</template>

<script>
import { queryBrandImgList, maidianOpenreal } from '@/apis/common';
import { getBannerJumpUrl } from '@/utils/activityUrl';
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';
import BaseDownLoad from '@/component/base-download';
import Market from '@/component/market';
import ExpertComments from '@/component/expert-comments';
import DataAnalyse from '@/component/data-analyse';
import BaseService from '@/component/base-service';
import { analyticalData } from '@/utils/tools';
import { Dialog } from 'vant';

export default {
  name: 'Index',
  components: {
    BaseHeader,
    BaseFooter,
    BaseDownLoad,
    Market,
    ExpertComments,
    DataAnalyse,
    BaseService
  },
  metaInfo: {
    title: '红狮金业官网|持牌正规贵金属交易平台|黄金白银交易首选',
    meta: [
      { name: 'keywords', content: '红狮金业,红狮贵金属平台,伦敦金交易,伦敦银交易,现货黄金交易,现货白银交易,正规贵金属交易平台' },
      { name: 'description', content: '“红狮金业为香港黄金交易所AA类081持牌行员，深耕贵金属交易多年，提供伦敦金、伦敦银实时行情交易、正版MT4/MT5软件、资金隔离托管、7×24小时专业客服，服务全球投资者，出入金顺畅安全。' }
    ]
  },
  data() {
    return {
      // swiper 参数
      swiperOption: {
        slidesPerView: 1,
        // swiper图片之间的间隔
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        preventClicks: true,
        //自动播放
        autoplay: {
          delay: 4000, //延迟播放下一张图片
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      // 获取到的swiper链接地址
      swiperData: {},
      screenWidth: document.body.clientWidth,//实时屏幕宽度
      // 市场数据
      London: {
        gold: '--',
        silver: '--',
        usd: '--',
        nas: '--',
        goldRise: '0.0',
        silverRise: '0.0',
        usdRise: '0.0',
        nasRise: '0.0',
        goldPer: '0.00%',
        silverPer: '0.00%',
        usdPer: '0.00%',
        nasPer: '0.00%',
      
        goldStatus: true,
        silverStatus: true,
        usdStatus: true,
        nasStatus: true,
      },
      isShow: true,//是否展示财经日历
     
      showType:true
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false

    };
    maidianOpenreal({ eventname: 'z1', eventdescribe: '访客数据', eventType: 'visit' });
    this.getBannerImg();
    
    
  },
  mounted() {
  // 初始化websocket
    const Rhref = window.location.host;   
    this.initWebSocket('wss://' + Rhref + '/quote');

  },
  methods: {
    getBannerImg() {
      const params = {
        languageIdentification: '1',
        type: this.screenWidth > 500 ? '20' : '67',
        brandId: '49',
        region: '1',
      }
      queryBrandImgList(params).then((res) => {
        console.log('banner数据--------', res)
        if (res && res.length > 0) {
          this.swiperData = res;
        } else {
          console.log('屏幕宽度', this.screenWidth)
          if (this.screenWidth > 500) {
            this.swiperData = [
              {
                imgUrl: require('@/assets/imgs/home/banner.png')
              }
            ];
          } else {
            this.swiperData = [
              {
                imgUrl: require('@/assets/imgs/home/wap/banner.png')
              }
            ];
          }

        }
        if (this.swiperData.length < 2) {
          this.swiperOption.loop = false;
        }
      })
    },
    async handleJump(item) {
      const url = await getBannerJumpUrl(item);
      url && window.open(url);
    },
    toScroll(name) {
      const element = this.$refs[name].$el;
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },

    // ----------------------------------------------------------websocket相关-------------------------------------
    initWebSocket(src) {
      // const wsuri = 'wss://testwww.rlc525.com/quote';

      const wsuri = src;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      let actions = { t: 7, d: { k: 0, nq: true } };
      this.websocketsend(JSON.stringify(actions));
      // let actions2 = { t: 21, d: ['GOLD', 'SILVER', 'XTIUSD', 'UKOIL'] };
      let actions2 = { t: 21, d: ['GOLD', 'SILVER'] };
      this.websocketsend(JSON.stringify(actions2));
    },
    websocketonerror() {
      let _this = this;
      console.log('连接建立失败');
      const Rhref = window.location.host;
      this.initWebSocket('wss://' + Rhref + '/quote');
      // this.initWebSocket('wss://www.rlcproltd.net/quote');
      
    },
    websocketonmessage(e) {
      const data = JSON.parse(e.data);
      // console.log('data', data)
      if (data.t === 0) {
        for (const iterator of data.d) {
          const blob = window.atob(iterator.q);
          const symbol = analyticalData(data.d[0].q || '', 5);
          if (symbol.SymbolName.slice(0, 4) == 'GOLD') {
            // 伦敦金
            this.London.gold = symbol.Bid.toFixed(3);
            let gold = symbol.Bid;
            
           
          } else if (symbol.SymbolName.slice(0, 6) == 'SILVER') {
            // 伦敦银
            this.London.silver = symbol.Bid.toFixed(3);
            let silver = symbol.Bid;
           

          }
          // else if (symbol.SymbolName.slice(0, 6) == 'XTIUSD') {
          //   // 伦敦银
          //   this.London.usd = symbol.Bid.toFixed(3);
          //   let usd = symbol.Bid;
          //   if (Number(usd) > Number(this.London.usd)) {
          //     this.London.controlPicOther = true;
          //   } else {
          //     this.London.controlPicOther = false;
          //   }

          // }
          // else if (symbol.SymbolName.slice(0, 5) == 'UKOIL') {
          //   // 伦敦银
          //   this.London.nas = symbol.Bid.toFixed(3);
          //   let nas = symbol.Bid;
          //   if (Number(nas) > Number(this.London.nas)) {
          //     this.London.controlPicOther = true;
          //   } else {
          //     this.London.controlPicOther = false;
          //   }

          // }
        }
      } else if (data.t === 5) {
        // console.log('t=5');
        let open = data.d.filter((item) => {
          // if (/(GOLD|SILVER|XTIUSD|UKOIL)/.test(item.n)) {
          if (/(GOLD|SILVER)/.test(item.n)) {
            return item.n;
          }
        });
        open.forEach((element) => {
          if (element.n == 'GOLD') {
            // 伦敦金
            this.goldCl = element.cl;
          } else if (element.n == 'SILVER') {
            // 伦敦银
            this.silverCl = element.cl;
          }
          // else if (element.n == 'XTIUSD') {
          //   // 美国原油
          //   this.usdCl = element.cl;
          // }
          // else if (element.n == 'UKOIL') {
          //   // 纳斯达克指数
          //   this.nasCl = element.cl;
          // }
        });
      }
      // 伦敦金 计算涨幅;
      this.London.goldRise = (Number(this.London.gold) - Number(this.goldCl)).toFixed(2);
      // 计算百分比（涨幅/昨收）
      this.London.goldPer = ((this.London.goldRise / this.goldCl) * 100).toFixed(2) + '%';
      // 伦敦银 涨幅
      this.London.silverRise = (Number(this.London.silver) - Number(this.silverCl)).toFixed(3);
      // 计算百分比（涨幅/昨收）
      this.London.silverPer = ((this.London.silverRise / this.silverCl) * 100).toFixed(2) + '%';
      // // 美国原油 涨幅
      // this.London.usdRise = (Number(this.London.usd) - Number(this.usdCl)).toFixed(3);
      // // 计算百分比（涨幅/昨收）
      // this.London.usdPer = ((this.London.usdRise / this.usdCl) * 100).toFixed(2) + '%';
      // // 纳斯达克指数 涨幅
      // this.London.nasRise = (Number(this.London.nas) - Number(this.nasCl)).toFixed(3);
      // // 计算百分比（涨幅/昨收）
      // this.London.nasPer = ((this.London.nasRise / this.nasCl) * 100).toFixed(2) + '%';
    },
    websocketsend(Data) {
      this.websock.send(Data);
    },
    websocketclose(e) {
      console.log('断开连接', e);
    },
  },
  watch: {
    'London.gold': function (newVal, oldVal) {
      if (oldVal !== '--' && newVal !== '--') {
        this.London.goldStatus = Number(newVal) > Number(oldVal);
      }
    },
    'London.silver': function (newVal, oldVal) {
      if (oldVal !== '--' && newVal !== '--') {
        this.London.silverStatus = Number(newVal) > Number(oldVal);
      }
    },
    'London.usd': function (newVal, oldVal) {
      if (oldVal !== '--' && newVal !== '--') {
        this.London.usdStatus = Number(newVal) > Number(oldVal);
      }
    },
    'London.nas': function (newVal, oldVal) {
      if (oldVal !== '--' && newVal !== '--') {
        this.London.nasStatus = Number(newVal) > Number(oldVal);
      }
    }
  },
}
</script>
<style lang="less" scoped>
.app-container {
  background: #fafafa;

  .content-box {
    width: 1240px;
    margin: auto;
    box-sizing: border-box;
    position: relative;
  }
 
  .banner__layer {
    position: relative;
    padding-top: 80px;

    .swiper-slide {
      position: relative;

      .banner-img {
        width: 100%;
        height: 28vw;
      }
    }

    /deep/.swiper-pagination {

      bottom: 20px;
      z-index: 20;

      .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: #FFFFFF !important;
        opacity: 1;
      }

      .swiper-pagination-bullet-active {
        background: #FA2314 !important;
        width: 38px;
        border-radius: 8px;
      }
    }

    .banner-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #000;

      .title {
        display: block;
      }

      .titles {
        display: none;
      }

      h1 {
        font-size: 68px;
        margin: 0;
      }

      &-intro {
        font-size: 18px;
      }

      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #0F0F11;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }

    .top-box {
      display: block;
      width: 1240px;
      height: 100px;
      padding: 26px 38px;
      box-sizing: border-box;
      background: #fff;
      // position: absolute;
      // bottom: -6%;
      // left: 50%;
      // transform: translateX(-50%);
      // z-index: 100;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px 0px 40px 0px #0000000f;
      margin: 3% auto 0;

      div {
        .left div:nth-child(1) {
          line-height: 21px;
          font-size: 16px;
          color: #000;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .left div:nth-child(2) {
          span {
            font-size: 14px;
            line-height: 19px;
            color: #11c771;
          }
        }
      }

      .slider {
        color: #fa2314;
        margin-left: 17px;
      }

      .slider1 {
        margin-left: 17px;

      }

      .right {
        width: 96px;
        height: 40px;
        background: #fa2314;
        font-size: 16px;
        line-height: 21px;
        font-weight: 700;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 24px;
      }

      .rights {
        background: #11c771;

      }
    }

    .topWapbox {
      display: none;
    }

    .topbox {
      display: none;

      margin: 5% auto 0;
      height: 40px;

      display: flex;
      align-items: center;
      justify-content: center;
      // position: absolute;
      // left: 3%;
      // bottom: -4%;
      // z-index: 10;
      white-space: nowrap;
      flex-wrap: wrap;
      width: 94%;

      .boxs {
        // max-width: 164px;
        width: 40%;
        border-radius: 4px;
        height: 40px;
        background: #fff;
        color: #fff;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 10px 12px;
        box-sizing: border-box;

        .left {
          background: #1552ac;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          font-size: 14px;
          line-height: 19px;
          margin-right: 7px
        }

        .right {
          font-size: 12px;
          line-height: 17px;

          .txt {
            font-size: 10px;
            color: #93939f;
            width: 36px;
          }

          .txts {
            color: #0F0F11;
            font-size: 12px;
            line-height: 17px;
            font-weight: 600;

          }

          .cont {
            display: flex;
            // flex-direction: column;
          }
        }
      }
    }

    .flex {
      display: flex;
      align-items: center;
    }

    .flex1 {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .top-flex {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .title__layer {
    text-align: center;
    padding: 70px 0 50px;

    .title {
      display: block;
    }

    .titles {
      display: none;
    }

    h1 {
      font-size: 46px;
      margin: 0;
      color: #000;
      margin-bottom: 10px;

      span {
        color: #FA2314;
      }
    }

    p {
      color: #0F0F11;
      font-size: 18px;
    }
  }

  .expert__layer {
    margin-top: 30px;
  }

  // 设置swiper分页器的样式
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal>.swiper-pagination-bullets {
    bottom: 55px;
  }
}

// ------------------wap----------------
@media screen and (max-width: 500px) {
  .app-container {
   
    .banner__layer {
      padding-top: 50px;

      .swiper-slide {
        .banner-img {
          height: 626px;
        }
      }

      .banner-content {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        color: #000;

        .title {
          display: none;
        }

        .titles {
          display: block;
        }

        h1 {
          font-size: 58px;
          line-height: 77px;
          margin: 0;
          width: 100%;
          text-align: center;
          white-space: wrap;
        }

        &-intro {
          font-size: 14px;
          text-align: center;
        }

        &-download {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 20px;

          &-btn {
            width: 180px;
            line-height: 34px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 20px;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #0F0F11;
              padding: 2px 20px;
              font-size: 10px;

              &:first-child {
                border-right: 1px solid #0F0F11;
              }

              img {
                width: 24px;
                height: 24px;
                margin-right: 12px;
              }
            }
          }
        }
      }

      .topWapbox {
        display: block;
      }

      .top-box {
        display: none;
      }
    
        .banner-co {
          top: 33%;
        }
        
      }
        .bannerss {
          padding-top: 0;
        }
    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }

    .title_layers {
      padding: 80px 0 50px;
    }

    .title__layer {
      .title {
        display: none;
      }

      .titles {
        display: block;
      }

      h1 {
        font-size: 36px;
        line-height: 48px;
      }

      p {
        font-size: 14px;
      }
    }
 }

}


//---------------- 小屏幕---------------------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {

  .app-container {
    background: #fafafa;

    .content-box {
      width: 1000px;
      margin: auto;
      box-sizing: border-box;
    }

    .banner__layer {
      position: relative;
      // padding-top: 80px;

      .swiper-slide {
        position: relative;

        .banner-img {
          width: 100%;
          height: 28vw;
        }
      }

      /deep/.swiper-pagination {
        background: #000;
        bottom: 20px;
        z-index: 20;

        .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          background: #FFFFFF !important;
          opacity: 1;
        }

        .swiper-pagination-bullet-active {
          background: #FA2314 !important;
          width: 38px;
          border-radius: 8px;
        }
      }

      .banner-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        color: #000;

        .title {
          display: block;
        }

        .titles {
          display: none;
        }

        h1 {
          font-size: 50px;
          margin: 0;
        }

        &-intro {
          font-size: 18px;
        }

        &-download {
          display: flex;
          align-items: center;
          margin-top: 50px;

          &-btn {
            width: 198px;
            line-height: 56px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 20px;
            font-weight: 700;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #0F0F11;
              padding: 4px 40px;

              &:first-child {
                border-right: 1px solid #0F0F11;
              }

              img {
                width: 38px;
                height: 38px;
                margin-right: 12px;
              }
            }
          }
        }
      }

      .top-box {
        display: block;
        width: 1000px;
        height: 100px;
        padding: 26px 38px;
        box-sizing: border-box;
        background: #fff;
        // position: absolute;
        // bottom: -6%;
        // left: 50%;
        // transform: translateX(-50%);
        // z-index: 100;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0px 0px 40px 0px #0000000f;
        // margin: 3% auto 0;

        div {
          .left div:nth-child(1) {
            line-height: 21px;
            font-size: 16px;
            color: #000;
            font-weight: 700;
            margin-bottom: 8px;
          }

          .left div:nth-child(2) {
            span {
              font-size: 14px;
              line-height: 19px;
              color: #11c771;
            }
          }
        }

        .slider {
          color: #fa2314;
          margin-left: 17px;
        }

        .slider1 {
          margin-left: 17px;

        }

        .right {
          width: 96px;
          height: 40px;
          background: #fa2314;
          font-size: 16px;
          line-height: 21px;
          font-weight: 700;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 24px;
        }

        .rights {
          background: #11c771;

        }
      }

      .topWapbox {
        display: none;
      }

      .topbox {
        display: none;

        margin: 0 auto;
        height: 40px;

        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 1rem;
        bottom: -4%;
        z-index: 10;
        white-space: nowrap;
        flex-wrap: wrap;

        .boxs {
          // max-width: 164px;
          width: 40%;
          border-radius: 4px;
          height: 40px;
          background: #fff;
          color: #fff;
          margin-right: 10px;
          margin-bottom: 10px;
          padding: 10px 12px;
          box-sizing: border-box;

          .left {
            background: #1552ac;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            font-size: 14px;
            line-height: 19px;
            margin-right: 7px
          }

          .right {
            font-size: 12px;
            line-height: 17px;

            .txt {
              font-size: 10px;
              color: #93939f;
              width: 36px;
            }

            .txts {
              color: #0F0F11;
              font-size: 12px;
              line-height: 17px;
              font-weight: 600;

            }

            .cont {
              display: flex;
              // flex-direction: column;
            }
          }
        }
      }

      .flex {
        display: flex;
        align-items: center;
      }

      .flex1 {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .top-flex {
        display: flex;
        align-items: center;
      }
    }

    .title__layer {
      text-align: center;
      padding: 70px 0 50px;

      .title {
        display: block;
      }

      .titles {
        display: none;
      }

      h1 {
        font-size: 46px;
        margin: 0;
        color: #000;
        margin-bottom: 10px;

        span {
          color: #FA2314;
        }
      }

      p {
        color: #0F0F11;
        font-size: 18px;
      }
    }

    .expert__layer {
      margin-top: 30px;
    }
  
       
    // 设置swiper分页器的样式
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
      bottom: 55px;
    }
  }
}

@media screen and (min-width: 1517px) and (max-width: 1600px) {
  .app-container {
    background: #fafafa;

    .content-box {
      width: 1000px;
      margin: auto;
      box-sizing: border-box;
    }

    .banner__layer {
      position: relative;
      // padding-top: 80px;

      .swiper-slide {
        position: relative;

        .banner-img {
          width: 100%;
          height: 28vw;
        }
      }

      /deep/.swiper-pagination {
        background: #000;
        bottom: 20px;
        z-index: 20;

        .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          background: #FFFFFF !important;
          opacity: 1;
        }

        .swiper-pagination-bullet-active {
          background: #FA2314 !important;
          width: 38px;
          border-radius: 8px;
        }
      }

      .banner-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        color: #000;

        .title {
          display: block;
        }

        .titles {
          display: none;
        }

        h1 {
          font-size: 50px;
          margin: 0;
        }

        &-intro {
          font-size: 18px;
        }

        &-download {
          display: flex;
          align-items: center;
          margin-top: 50px;

          &-btn {
            width: 198px;
            line-height: 56px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 20px;
            font-weight: 700;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #0F0F11;
              padding: 4px 40px;

              &:first-child {
                border-right: 1px solid #0F0F11;
              }

              img {
                width: 38px;
                height: 38px;
                margin-right: 12px;
              }
            }
          }
        }
      }

      .top-box {
        display: block;
        width: 1000px;
        height: 100px;
        padding: 26px 38px;
        box-sizing: border-box;
        background: #fff;
        // position: absolute;
        // bottom: -6%;
        // left: 50%;
        // transform: translateX(-50%);
        // z-index: 100;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0px 0px 40px 0px #0000000f;
        // margin: 0 auto;

        div {
          .left div:nth-child(1) {
            line-height: 21px;
            font-size: 16px;
            color: #000;
            font-weight: 700;
            margin-bottom: 8px;
          }

          .left div:nth-child(2) {
            span {
              font-size: 14px;
              line-height: 19px;
              color: #11c771;
            }
          }
        }

        .slider {
          color: #fa2314;
          margin-left: 17px;
        }

        .slider1 {
          margin-left: 17px;

        }

        .right {
          width: 96px;
          height: 40px;
          background: #fa2314;
          font-size: 16px;
          line-height: 21px;
          font-weight: 700;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 24px;
        }

        .rights {
          background: #11c771;

        }
      }

      .topWapbox {
        display: none;
      }

      .topbox {
        display: none;

        margin: 0 auto;
        height: 40px;

        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 1rem;
        bottom: -4%;
        z-index: 10;
        white-space: nowrap;
        flex-wrap: wrap;

        .boxs {
          // max-width: 164px;
          width: 40%;
          border-radius: 4px;
          height: 40px;
          background: #fff;
          color: #fff;
          margin-right: 10px;
          margin-bottom: 10px;
          padding: 10px 12px;
          box-sizing: border-box;

          .left {
            background: #1552ac;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            font-size: 14px;
            line-height: 19px;
            margin-right: 7px
          }

          .right {
            font-size: 12px;
            line-height: 17px;

            .txt {
              font-size: 10px;
              color: #93939f;
              width: 36px;
            }

            .txts {
              color: #0F0F11;
              font-size: 12px;
              line-height: 17px;
              font-weight: 600;

            }

            .cont {
              display: flex;
              // flex-direction: column;
            }
          }
        }
      }

      .flex {
        display: flex;
        align-items: center;
      }

      .flex1 {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .top-flex {
        display: flex;
        align-items: center;
      }
    }
   
    .title__layer {
      text-align: center;
      padding: 70px 0 50px;

      .title {
        display: block;
      }

      .titles {
        display: none;
      }

      h1 {
        font-size: 40px;
        margin: 0;
        color: #000;
        margin-bottom: 10px;

        span {
          color: #FA2314;
        }
      }

      p {
        color: #0F0F11;
        font-size: 18px;
      }
    }

    .expert__layer {
      margin-top: 30px;
    }

         
    // 设置swiper分页器的样式
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
      bottom: 55px;
    }
  }
}
</style>